import { SDK } from '@redge-media/fo-js-sdk';

export default function Document(alias, opts = {}) {
  const promise = {};

  return {
    isFetched: false,
    data: [],
    fetch() {
      if (promise.pending) {
        return promise.value;
      }

      promise.value = new Promise((resolve, reject) => {
        promise.pending = true;
        let path = `/documents/${alias}`;

        if (opts.content) {
          path += '/content';
        }

        promise.adapterSource = SDK.apiAdapter.getSource();
        SDK.apiAdapter.get(path, {}, { cancelToken: promise.adapterSource.token }).then((resp) => {
          this.data = resp.data;
          resolve(resp.data);
          promise.pending = false;
          this.isFetched = true;
        }).catch((e) => {
          reject(e);
          promise.pending = false;
          this.isFetched = false;
        });
      });

      return promise.value;
    },
    abort() {
      promise.adapterSource.cancel();
    },
  };
}
